"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpLoadingWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var classnames_1 = __importDefault(require("classnames"));
/**
 *  Button params
 *
 * @property {any}       children   - Elements displayed when invoking the component.
 * @property {any}       onClick    - Callback fired when a button is clicked
 *
 * @author ricardo.salazar
 * @author javier.perez
 */
var DpLoadingWrapper = function (_a) {
    var children = _a.children, as = _a.as, onClick = _a.onClick, _b = _a.replaceChildren, replaceChildren = _b === void 0 ? false : _b, props = __rest(_a, ["children", "as", "onClick", "replaceChildren"]);
    var _c = (0, react_1.useState)(false), loading = _c[0], setLoading = _c[1];
    var spinner = ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Spinner, { as: "span", className: (0, classnames_1.default)({ 'mr-1': !replaceChildren }), animation: "border", size: "sm", role: "status" }));
    var handleCall = function () {
        var handler = !loading ? onClick() : undefined;
        if (handler) {
            setLoading(true);
            return handler
                .then(function (destroyed) {
                // when true is because the parent component was destroyed
                return !destroyed && setLoading(false);
            })
                .catch(function () { return setLoading(false); });
        }
    };
    var Component = as || react_bootstrap_1.Button;
    return ((0, jsx_runtime_1.jsxs)(Component, __assign({}, props, { onClick: handleCall, children: [loading && spinner, (!loading || (loading && !replaceChildren)) && children] })));
};
exports.DpLoadingWrapper = DpLoadingWrapper;
exports.default = exports.DpLoadingWrapper;
